import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "spinner"]

  start() {
    this.element.setAttribute("aria-busy", "true")
    this.labelTarget.textContent = "Lodging with venue…"
    this.spinnerTarget.classList.remove("hidden")
  }

  finish() {
    this.element.removeAttribute("aria-busy")
    this.labelTarget.textContent = "Lodge With Venue"
    this.spinnerTarget.classList.add("hidden")
  }
}
